import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const F_FAMCLIENT_SCHEMA_LITERAL = {
    title: 'Schéma FamClients',
    description: 'Décrit les spécificités tarifaires par famille',
    version: 0,
    keyCompression: false,
    primaryKey: { key : 'CBMARQ_PK', fields : ['CBMARQ'], separator : '' },
    type: 'object',
    properties: {
        CBMARQ_PK: { type: 'string', maxLength : 10 },
        CBMARQ: { type: 'number' },
        FA_CODEFAMILLE: { type: 'string' },
        CT_NUM: { type: 'string' },
        FC_REMISE: { type: 'number' }
    },
    required: [ 'CBMARQ', 'FA_CODEFAMILLE', 'CT_NUM', 'FC_REMISE' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(F_FAMCLIENT_SCHEMA_LITERAL);
export type RxFFamClientDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;
export const F_FAMCLIENT_SCHEMA: RxJsonSchema<RxFFamClientDocumentType> = F_FAMCLIENT_SCHEMA_LITERAL;